// extracted by mini-css-extract-plugin
export default {"productModal":"ByProductModal_productModal__TSDhf"};